(() => {
  function readSection(sectionHtml) {
    if (!sectionHtml) return null;
    const document = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const state = document.querySelector('[data-cart-state]');
    if (!state) return null;
    const count = Number(state.dataset.cartItemCount);
    if (!Number.isInteger(count) || count < 0) return null;
    return { count, label: state.dataset.cartLabel };
  }

  function sync(itemCount, label) {
    if (itemCount === undefined || itemCount === null) return;
    const count = Number(itemCount);
    if (!Number.isInteger(count) || count < 0) return;
    const strings = window.cartStrings || {};
    const template = count === 1 ? strings.item : strings.items;
    const accessibleLabel = label || template?.replace('[count]', String(count));
    const visibleCount = count < 100 ? String(count) : (strings.item_99 || '99+');

    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = element.closest('.cart-text') ? `(${visibleCount})` : visibleCount;
    });

    if (accessibleLabel) {
      document.querySelectorAll('[data-cart-text]').forEach((element) => {
        element.textContent = accessibleLabel;
      });
    }

    document.querySelectorAll('button.cart-icon--drawer, a.cart-icon--drawer').forEach((trigger) => {
      if (accessibleLabel) trigger.setAttribute('aria-label', accessibleLabel);
      trigger.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        bubble.hidden = count === 0;
      });
    });
  }

  window.GoodwoodCartHeader = { readSection, sync };

  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail?.data || event.detail?.cartData || event.detail;
    const state = readSection(cart?.sections?.['cart-icon-bubble']);
    sync(cart?.item_count ?? state?.count, state?.label);
  });
})();